<script lang="ts">
	import type { CmsWorldRecord } from '$lib/data/types';
	import { _, locale } from 'svelte-i18n';
	import { localizeUrl } from '$lib/i18n';

	export let worlds: CmsWorldRecord[];

	let show = false;
</script>

<ul class="navbar-nav navbar-nav--main-selection" on:mouseleave={() => (show = false)}>
	<li class="nav-item dropdown">
		<!-- svelte-ignore a11y-invalid-attribute -->
		<a
			class="nav-link dropdown-toggle"
			href="#"
			role="button"
			aria-expanded={show}
			on:click|preventDefault={() => (show = !show)}
		>
			{$_('page.titleShort')}
		</a>

		<ul class="dropdown-menu" class:show>
			{#each worlds as world}
				<li>
					<a
						href={localizeUrl(world.url, $locale)}
						rel="external"
						target={world.url.startsWith('http') ? '_blank' : undefined}
						class="dropdown-item"
						class:is-primary={world.primary}
						on:click={() => (show = false)}
					>
						{world.title}
					</a>
				</li>
			{/each}
		</ul>
	</li>
</ul>

<style>
	ul.dropdown-menu {
		width: 10.5rem;
	}

	a.nav-link.dropdown-toggle {
		width: 100%;
	}
</style>
